/**
 * en-GB messages added by Phase 2 task S19 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s19EnGB = {
    'nav.ompLink': 'Oakford Mobile Portal',
    'omp.error.not_connected': 'The Oakford Mobile Portal link has not been set up yet. Use Connect first.',
    'omp.error.group_not_repeat': 'Choose a group for regular visitors or staff (a repeat group), such as "Staff".',
};
//# sourceMappingURL=s19.js.map